import { push } from 'connected-react-router'
import { getPageLocation } from 'selectors'
import { getCompareTrayItems } from '../selectors'
import { COMPARE_PAGE } from 'constant'
import { SRP_PATHNAME } from '../constants'

export const compareItems = () => (dispatch, getState) => {
  const items = getCompareTrayItems(getState())
  const itemsQuery = `compareItems=${items.map(({ skuId }) => skuId).join()}`

  const { pathname } = getPageLocation(getState())
  let { search } = getPageLocation(getState())
  const subString = 'promotionId'

  // We are doing this to fix bug when vehicle tire size contain search query parameter. See BOT-3754 ticket.
  if (search.includes(subString)) {
    search = ''
  }

  const srpQueryParam = `${SRP_PATHNAME}=${pathname}${search}`

  dispatch(push(`${COMPARE_PAGE}?${itemsQuery}&${srpQueryParam}`))
}
